import React, {useState} from "react";
import {Form, Formik} from "formik";
import "./index.scss"
import {Button} from "../../Button";
import {InputTextMaskOld} from "../../inputs/InputTextMaskOld";
import {strings} from "../../../strings/strings";
import {DateSelectOld} from "../../inputs/DatePickerOld";
import {addYears} from "../../../utils/dateUtils";
import moment from "moment";
import { TravelAdvantagesList } from "../../travelAdvantagesList";
import { ImportantInfo } from "../../ImportantInfo";
import Grid from '@material-ui/core/Grid';
import { SimpleTooltip } from "../../SimpleTooltip";

interface TravelPhoneNumberDialogProps {
    isOpen: boolean;
    onSubmit: (values: {
        phone: string,
        birthDate: Date,
    }) => Promise<void>;
}

/*
    А це формочка куди вводимо номер телефону та дату для подальшого пошуку
*/

export const TravelPhoneNumberDialog = (props: TravelPhoneNumberDialogProps) => {
    const {isOpen} = props;
    const [process, setProcess] = useState(false);
    const onSubmit = async (values) => {
        setProcess(true);
        await props.onSubmit(values);
        setProcess(false);
    }
    const validate = values => {
        const errors: any = {};
        if (!values.phone) {
            errors.phone = strings.emptyFieldErrorMessage;
        }
        if (!values.birthDate) {
            errors.birthDate = strings.emptyFieldErrorMessage;
        }
        return errors;
    }
    return (
        <div>
            {isOpen &&
            <div className={"travel-phone-number-dialog"}>
                <Formik
                    initialValues={{
                        phone: '',
                        birthDate: null,
                    }}
                    onSubmit={onSubmit}
                    validate={validate}
                    validateOnBlur={false}
                    validateOnChange={false}
                >
                    {formProps => (
                        <Form>
                            <div className="dialog-one__content">
                                <span className={"travel-phone-number-dialog__title"}>{strings.travelDialog.text1}</span>

                                <Grid container spacing={4}>
                                    <Grid item xs={12} sm={12} md={6} lg={6}>
                                        <div className="travel-phone-number-dialog__field-wrapper">
                                            <InputTextMaskOld name={'phone'}
                                                label={strings.personalInfoLivingPhone}
                                                mask={"+38(999)999-99-99"}
                                            />
                                            <SimpleTooltip title={<>{strings.travelDialog.text3}</>}>
                                                {strings.travelDialog.text4}
                                            </SimpleTooltip>
                                        </div>
                                        
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={6} lg={6}>
                                        <DateSelectOld name={'birthDate'}
                                            label={strings.personalInfoBirthDate }
                                            placeholder={strings.datePlaceholder}
                                            minDate={addYears(new Date(), -100)}
                                            maxDate={addYears(new Date(), -18)}
                                            disabled={false}
                                            hidden={false}
                                            defaultValue={formProps.values.birthDate}
                                            formatResponse={(option: string) => {
                                                const date = moment(option, 'DD.MM.YYYY').toDate();
                                                return {
                                                    quotationValue: moment(date).format('YYYY-MM-DD'),
                                                    value: moment(date).format('DD.MM.YYYY')
                                                }
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                                

                                <div className="start-form-step_submit-button" style={{ marginBottom: 0, marginTop:'16px'}}>
                                    <Button id={'toolbarCheck'}
                                            label={strings.toolbarCheck}
                                            isProcess={process}
                                            onClickListener={formProps.handleSubmit}/>
                                </div>
                                <div className={"vehicle-search-view__search__help"}>
                                    <span>{strings.travelDialog.text2}</span>
                                </div>
                                <TravelAdvantagesList />
                                <ImportantInfo />
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
            }
        </div>
    )

}